import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PoNotificationService, PoSwitchLabelPosition } from '@po-ui/ng-components';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { CONSTANTS } from 'src/app/constants';
import { ModalPersonStatisticsComponent } from '../modal-person-statistics/modal-person-statistics.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sales-record',
  templateUrl: './sales-record.component.html',
  styleUrls: ['./sales-record.component.css']
})
export class SalesRecordComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  @ViewChild('modalStats', { static: false }) modalStats!: ModalPersonStatisticsComponent;
  @Output() errorEmitter = new EventEmitter();

  personStatisticsInfo: any = 0;
  limitPersonInfo: number = 0;
  openInvoiceValue: number = 0;
  personSelect: any = {};
  filterInicial: any = {}
  branchCodes: any[] = [];
  tableItens: any[] = [];
  tableItensOriginal: any[] = [];
  ordem: boolean = true;
  typeSelected: any = 0;
  loading: boolean = false;

  dataApi = {
    branchs: []
  }
  labelPosition: PoSwitchLabelPosition = PoSwitchLabelPosition.Left;
  compraStatus: boolean = true;
  topTooltip: string = 'Registro de vendas dos últimos 90 dias';
  errorApi: boolean = false;
  message: string = "";

  constructor(private api: ApiService, private poNotification: PoNotificationService, private router: Router) { }

  ngOnInit(): void {
  }

  filterItem(item: any) {
    this.filterInicial = item;
    this.loading = true;
    this.tableItens = [];
    this.tableItensOriginal = [];
    if (item.branch != undefined) {
      this.dayCountReturn(item).subscribe((data: any) => {
        this.dataApi = item;
        let excelInfo: any[] = [];
        data.dataRow.slice(0, 5).map((el: any) => {
          this.tableItens.push({
            "personCode": el.personCode,
            "cliente": el.personName,
            "ultimaCompra": this.formatDate(el.lastPurchaseDate),
            "contato": el.personPhone,
          });
          this.tableItensOriginal = this.tableItens;
          excelInfo.push({ 'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Status': this.compraStatus ? 'COMPROU RECENTE' : 'NÃO COMPROU RECENTE', 'Cliente': el.personName, 'Última Compra': el.days, 'Contato': el.phoneNumber });
        });
        excelInfo.unshift({});
        localStorage.setItem('sales-record-sellers', JSON.stringify(excelInfo));
        this.loading = false;
        this.errorApi = false;
      },
        (error) => {
          this.loading = false;
          this.errorApi = true;
          this.message = CONSTANTS.MESSAGES.DATA_ERRO_SALES_RECORD;
          this.formatErrorMensagem(error.message);
        });
    }
  }

  openChart(item: any) {
    this.personSelect = item;
    const filterInfoBranchs = localStorage.getItem("filterInfoBranchs");
    this.branchCodes = filterInfoBranchs ? JSON.parse(filterInfoBranchs) : this.filterInicial.branch;
    this.modalStats.open(item, this.branchCodes);
  }

  personStatisticsReturn(item: any) {
    const filterInfoBranchs = localStorage.getItem("filterInfoBranchs");
    const parsedBranches = filterInfoBranchs ? JSON.parse(filterInfoBranchs) : this.filterInicial.branch;

    return this.api.getPersonStatistics(item.personCode, parsedBranches);
  }

  limitsPersonReturn(item: any) {
    const filterInfoBranchs = localStorage.getItem("filterInfoBranchs");
    const parsedBranches = filterInfoBranchs ? JSON.parse(filterInfoBranchs) : this.filterInicial.branch;

    return this.api.postCustomerFinancialBalance(item.personCode, parsedBranches);
  }

  copyContact(item: any) {
    navigator.clipboard.writeText(item).then(() => {
      this.poNotification.success('contato copiado com sucesso!');
    }).catch((err: any) => {
      this.poNotification.error('Erro ao copiar o contato!');
    });
  }

  sendWa(item: any) {
    const encodedMessage = encodeURIComponent(CONSTANTS.MESSAGES.DATA_MESSAGE_WHATSAPP);
    const plusCountry = '55' + item.replace(/\D/g, '');
    const url = `https://wa.me/${plusCountry}?text=${encodedMessage}`;
    window.open(url, '_blank');
  }

  formatDate(item: any) {
    let data = item;
    let dataSplit = data.split('-');
    let diaSplit = dataSplit[2].split('T');
    let dia = diaSplit[0];
    let mes = dataSplit[1];
    let ano = dataSplit[0];
    return dia + "/" + mes + "/" + ano;
  }

  changeCompraStatus() {
    this.tableItens = [];
    this.filterItem(this.dataApi);
  }

  dayCountReturn(item: any) {
    return this.api.postDayCountSellerPanel(item.branch, this.compraStatus);
  }

  ordenarTabela(colunaTipo: any) {
    this.loading = true;
    if (colunaTipo === 'cliente') {
      this.tableItens = this.tableItensOriginal;
      this.tableItens.sort((a: any, b: any) => {
        if (this.ordem) return a.cliente[0].toLowerCase().localeCompare(b.cliente[0].toLowerCase())
        if (!this.ordem) return b.cliente[0].toLowerCase().localeCompare(a.cliente[0].toLowerCase())
      });

      const iconCliente = document.getElementById('icon-cliente-sales-record');
      this.ordem
        ? (
          iconCliente!.classList.remove('po-icon', 'po-icon-arrow-down'),
          iconCliente!.classList.add('po-icon', 'po-icon-arrow-up')
        )
        : (
          iconCliente!.classList.remove('po-icon', 'po-icon-arrow-up'),
          iconCliente!.classList.add('po-icon', 'po-icon-arrow-down')
        )

      this.ordem = !this.ordem;
      this.loading = false;
    }
    if (colunaTipo === 'data') {
      this.tableItens.sort((a: any, b: any) => {
        const [diaA, mesA, anoA] = a.ultimaCompra.split('/').map(Number);
        const [diaB, mesB, anoB] = b.ultimaCompra.split('/').map(Number);

        const dataA = new Date(anoA, mesA - 1, diaA);
        const dataB = new Date(anoB, mesB - 1, diaB);

        return this.ordem ? dataA.getTime() - dataB.getTime() : dataB.getTime() - dataA.getTime();
      });

      const iconData = document.getElementById('icon-data-sales-record');
      this.ordem
        ? (
          iconData!.classList.remove('po-icon', 'po-icon-arrow-down'),
          iconData!.classList.add('po-icon', 'po-icon-arrow-up')
        )
        : (
          iconData!.classList.remove('po-icon', 'po-icon-arrow-up'),
          iconData!.classList.add('po-icon', 'po-icon-arrow-down')
        )

      this.ordem = !this.ordem;
      this.loading = false;
    }
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataSalesRecord = [];
    let objectSalesRecord = localStorage.getItem('sales-record-sellers');

    objectSalesRecord != null
      ? (dataSalesRecord = JSON.parse(objectSalesRecord))
      : (dataSalesRecord = []);
    const worksheetSalesRecord = XLSX.utils.json_to_sheet(dataSalesRecord);

    const workbook = {
      Sheets: {
        'sales-record': worksheetSalesRecord,
      },
      SheetNames: [
        'sales-record',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-sales-record' + EXCEL_EXTENSION);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: sales-record \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

  goToSalesRecordDetails() {
    localStorage.setItem('filterInfoBranchs', JSON.stringify(this.filterInicial.branch));
    localStorage.setItem('filterInfoMinDate', JSON.stringify(this.filterInicial.dataMin));
    localStorage.setItem('filterInfoMaxDate', JSON.stringify(this.filterInicial.dataMax));
    this.router.navigate(['/sales-record-detail'],
      { queryParams: { 'branch': this.filterInicial.branch, 'boughtRecently': this.compraStatus } }
    );
  }

}
